module.exports = __webpack_public_path__ + "static/media/proj3.fc8028c7.webp";